import { Component, OnInit, Renderer2 } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { fromEvent } from 'rxjs';
import { AccountUserService } from './service/account.service';
import { ScriptService } from './service/script-import.service';

const GOOGLEMAP_SCRIPT_PATH = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDe4eFGUfn88nHM6fDkRt_vk-vEfEohWHU&map_ids=656915a1a1b695a4&libraries=geometry,drawing,places,marker&v=weekly&callback=initGoogleMap';
declare var google: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit {

    name = 'Angular';
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    timeouttime: any = 60;
    resdata: any;
    countdown?: number = null;
    checkRefresh = false;

    constructor(
        private renderer: Renderer2,
        private userService: AccountUserService,
        private translocoService: TranslocoService,
        private scriptService: ScriptService
    ) {

    }

    ngOnInit() {
        //this.subscribeToSessionLogout();
        this.loadGoogleMapScript();
    }

    //User logout after browser close/all tabs close
    private subscribeToSessionLogout() {
        fromEvent(window, 'load')
            .subscribe((e) => {
                let logoutSession = localStorage.getItem('logoutSession');

                if (logoutSession) {
                    localStorage.removeItem('logoutSession');
                    let logoutSessionTime = parseInt(logoutSession);
                    let nowTIme = Date.now();

                    if ((nowTIme - logoutSessionTime) > (10 * 1000)) {
                        localStorage.removeItem('TabsOpen');
                        this.userService.logout();
                    }
                }

                let addedSession = sessionStorage.getItem('TabHash');
                let addedStorage = localStorage.getItem('TabsOpen') || {};

                if (!addedSession || !addedStorage.hasOwnProperty(addedSession)) {
                    let hash = 'tab_' + +new Date();
                    sessionStorage.setItem('TabHash', hash);
                    let tabs = JSON.parse(localStorage.getItem('TabsOpen') || '{}');
                    tabs[hash] = true;
                    localStorage.setItem('TabsOpen', JSON.stringify(tabs));
                }

                let tabsCount = Object.keys(JSON.parse(localStorage.getItem('TabsOpen') || '{}')).length;
                ////console.log(tabsCount);
            })

        fromEvent(window, 'beforeunload')
            .subscribe((e) => {
                let now = Date.now();
                let hash = sessionStorage.getItem('TabHash');
                let tabs = JSON.parse(localStorage.getItem('TabsOpen') || '{}');
                delete tabs[hash];
                localStorage.setItem('TabsOpen', JSON.stringify(tabs));
                let tabsCount = Object.keys(JSON.parse(localStorage.getItem('TabsOpen') || '{}')).length;
                ////console.log(tabsCount);
                if (tabsCount == 0) {
                    localStorage.setItem('logoutSession', JSON.stringify(now));
                }
            })
    }

    logout() {
        localStorage.clear();
        window.location.reload();
        //this.accountService.logout();

    }

    updateLocale(locale: any) {
        const lang = locale.substring(0, 2);
        this.translocoService.setActiveLang(lang);
    }

    loadGoogleMapScript() {
        const scriptElement = this.scriptService.loadJsScript(this.renderer, GOOGLEMAP_SCRIPT_PATH);
        scriptElement.onload = () => {
            this.initGoogleMap();
        }
        scriptElement.onerror = () => {

        }
    }

    initGoogleMap() {

    }
}
